import * as React from 'react';
import './index.css';
export default function PlatePerson(props) {
    var personData = props.personData;
    return (React.createElement("div", { className: 'plate_person_box' },
        React.createElement("div", { className: 'plate_person_item' },
            React.createElement("div", { className: 'plate_person_title' }, "\u6536\u6B3E\u4EBA\uFF1A"),
            React.createElement("div", { className: 'plate_person_text' }, personData.payee)),
        React.createElement("div", { className: 'plate_person_item' },
            React.createElement("div", { className: 'plate_person_title' }, "\u590D\u6838\u4EBA\uFF1A"),
            React.createElement("div", { className: 'plate_person_text' }, personData.reviewer)),
        React.createElement("div", { className: 'plate_person_item' },
            React.createElement("div", { className: 'plate_person_title' }, "\u5F00\u7968\u4EBA\uFF1A"),
            React.createElement("div", { className: 'plate_person_text' }, personData.drawer))));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/InvoicePlate/PlatePerson/index.js
// module id = 4217
// module chunks = 0